<script lang="ts">
  import TeamCard from './TeamCard.svelte'
  import micah from '$lib/assets/headshots/micah.jpg'
  import jay from '$lib/assets/headshots/jay.jpg'
  import dubbleu from '$lib/assets/headshots/dubbleu.jpg'
  import felipe from '$lib/assets/headshots/felipe.jpg'
  import lucas from '$lib/assets/headshots/lucas.jpg'
  import kasey from '$lib/assets/headshots/kasey.png'
  import martin from '$lib/assets/headshots/martin.png'
  import travis from '$lib/assets/headshots/travis.jpg'

  let teamText = '[ THE TEAM ]'

  const teamData = [
    {
      avatar: micah,
      name: 'Micah Kendall',
      position: 'Founder',
      xLink: 'https://x.com/MicahAlexKenda1',
      coreTeam: true,
    },
    {
      avatar: jay,
      name: 'Jay Taylor',
      position: 'Co-Founder',
      xLink: 'https://x.com/JayTayArray',
      coreTeam: true,
    },
    {
      avatar: felipe,
      name: 'Felipe Moreira',
      position: 'Frontend Developer',
      xLink: 'https://x.com/morfelidev',
      coreTeam: true,
    },

    {
      avatar: lucas,
      name: 'Lucas Rosa',
      position: 'VP of Engineering',
      xLink: 'https://x.com/rvcas',
      coreTeam: true,
    },
    {
      avatar: dubbleu,
      name: 'Dubbleu',
      position: 'Community Manager',
      xLink: 'https://x.com/Dubbleu_43',
      coreTeam: true,
    },
    {
      avatar: kasey,
      name: 'Kasey White',
      position: 'Advisor',
      xLink: 'https://x.com/MicroProofs',
      coreTeam: false,
    }
  ]
</script>

<div class="mx-auto max-w-screen-xl-desktop">
  <section class="m-4 my-14 flex flex-col justify-between">
    <h2 class="w-fit pl-4 font-cirka font-[12px] tracking-widest">{teamText}</h2>
    <ul
      class="m-4 grid grid-cols-[repeat(auto-fit,minmax(250px,1fr))] justify-items-center gap-2 md:grid-cols-2 lg:h-fit xl:grid-cols-3 lg-desktop:h-fit lg-desktop:gap-0"
    >
      <TeamCard
        avatar={teamData[0].avatar}
        name={teamData[0].name}
        position={teamData[0].position}
        xLink={teamData[0].xLink}
        coreTeam={teamData[0].coreTeam}
        backgroundImageStyle="scale-[0.97]"
      />

      <TeamCard
        avatar={teamData[1].avatar}
        name={teamData[1].name}
        position={teamData[1].position}
        xLink={teamData[1].xLink}
        coreTeam={teamData[1].coreTeam}
        backgroundImageStyle="scale-[0.97]"
      />

      <TeamCard
        avatar={teamData[2].avatar}
        name={teamData[2].name}
        position={teamData[2].position}
        xLink={teamData[2].xLink}
        coreTeam={teamData[2].coreTeam}
        backgroundImageStyle="scale-[0.97]"
      />

      <TeamCard
        avatar={teamData[3].avatar}
        name={teamData[3].name}
        position={teamData[3].position}
        xLink={teamData[3].xLink}
        coreTeam={teamData[3].coreTeam}
        backgroundImageStyle="scale-[0.97]"
      />

      <TeamCard
        avatar={teamData[4].avatar}
        name={teamData[4].name}
        position={teamData[4].position}
        xLink={teamData[4].xLink}
        coreTeam={teamData[4].coreTeam}
        backgroundImageStyle="scale-[0.97]"
      />

      <TeamCard
        avatar={teamData[5].avatar}
        name={teamData[5].name}
        position={teamData[5].position}
        xLink={teamData[5].xLink}
        coreTeam={teamData[5].coreTeam}
        backgroundImageStyle="scale-[0.97]"
      />
    </ul>
  </section>
</div>
